import { Message } from 'element-ui';
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    activeName: 'resource',
    questionsBasket: [],
    courseInformation: {
      courseId: '',
      lessonId: '',
    },
    atKnowledgeList: [],
    subjectObj: {
      subjectId: '',
      subjectName: '',
    },
    categoryObj: {
      subjectId: '',
      subjectName: '',
      gradeId: '',
      gradeName: '',
      textbookId: '',
      textbookName: '',
      termId: '',
      termName: '',
      lastClassList: '',
    },

    // 测评中心错题
    evaWrongCategoryObj: {
      crmSubjectId: '',
      dLSubjectId: '',
      subjectName: '',
      gradeId: '',
      crmGradeId: '',
      gradeName: '',
      bookVersionId: '',
      versionsName: '',
    },
    // 测评中心薄弱知识点
    evaWeakCategoryObj: {
      crmSubjectId: '',
      dLSubjectId: '',
      subjectName: '',
      gradeId: '',
      crmGradeId: '',
      gradeName: '',
      bookVersionId: '',
      versionsName: '',
    },
    // 练习中心高频错题
    commonWrongCategoryObj: {
      subjectId: '',
      subjectName: '',
      gradeId: '',
      gradeName: '',
      textbookId: '',
      textbookName: '',
      termId: '',
      termName: '',
    },
    // 练习中心薄弱知识点
    commonWeakCategoryObj: {
      subjectId: '',
      subjectName: '',
      gradeId: '',
      gradeName: '',
      textbookId: '',
      textbookName: '',
      termId: '',
      termName: '',
    },
    // 练习中心共性分析章节信息
    commonWeakCourseInformation: {
      courseId: '',
      lessonId: '',
    },
    testInfo: {
      testId: '',
      testName: '',
    },
    filtrateArray: [],
    selectTagArray: [],
    checkedWeakPointList: [],
    topicList: [],
    classSubjectList: [],
    LearnDetailObj: {},
    classSubjectId: '',
    classDateRange: [],
    knowLedgeParams: [],
    classCourseList: [],
    knowLedgeRange: [],
    knowSubjectList: [],
  },
  mutations: {
    SET_SUBJECT_OBJ: (state, data) => {
      state.subjectObj = data;
    },
    SET_CATEGORY_OBJ: (state, data) => {
      state.categoryObj = data;
      if (state.categoryObj.termName === '春季') {
        state.categoryObj.termName = '下';
      }
      if (state.categoryObj.termName === '秋季') {
        state.categoryObj.termName = '上';
      }
    },
    CHANGE_COURSE_INFORMATION(state, value) {
      state.courseInformation = value;
    },
    changeActive(state, value) {
      state.activeName = value;
    },
    PUTIN_QUESTIONS_BASKET(state, value) {
      let count = 0;
      state.questionsBasket.forEach((item) => {
        if (item.child_question_num > 0) {
          count += item.child_question_num;
        } else {
          count += 1;
        }
      });
      if (count === 50) {
        Message({
          message: '最多选择50道题',
          type: 'warning',
        });
        return;
      }
      state.questionsBasket = [...state.questionsBasket, value];
    },
    PUTOUT_QUESTIONS_BASKET(state, value) {
      const index = state.questionsBasket
        .findIndex((item) => item.question_uuid === value.question_uuid);
      state.questionsBasket.splice(index, 1);
    },
    CLEAR_QUESTIONS_BASKET(state, value) {
      state.questionsBasket = value;
    },
    CHOOSE_KNOWLEDGE(state, value) {
      state.atKnowledgeList = value;
    },
    FILTRATE_ARRAY(state, value) {
      state.filtrateArray = value;
    },
    SELECT_TAG_ARRAY(state, value) {
      state.selectTagArray = value;
    },
    SET_WEAK_POINT_LIST(state, value) {
      state.checkedWeakPointList = value;
    },
    CHANGE_TEST_INFORMATION(state, value) {
      state.testInfo = value;
    },
    SET_TOPIC_LIST(state, value) {
      state.topicList = value;
    },
    SET_COMMON_WRONG_CATEGORY_OBJ: (state, data) => {
      state.commonWrongCategoryObj = data;
    },
    SET_COMMON_WEAK_CATEGORY_OBJ: (state, data) => {
      state.commonWeakCategoryObj = data;
    },
    CHANGE_COMMON_WEAK_COURSE(state, value) {
      state.commonWeakCourseInformation = value;
    },
    SET_EVA_WRONG_CATEGORY_OBJ(state, value) {
      state.evaWrongCategoryObj = value;
    },
    SET_EVA_WEAK_CATEGORY_OBJ(state, value) {
      console.log({ value });
      state.evaWeakCategoryObj = value;
    },
    SET_CLASS_SUBJECT_LIST(state, value) {
      state.classSubjectList = value;
    },
    SET_KNOW_SUBJECT_LIST(state, value) {
      state.knowSubjectList = value;
    },
    SET_CLASS_SUBJECT_ID(state, value) {
      state.classSubjectId = value;
    },
    SET_LEARN_DETAIL_OBJ(state, value) {
      state.LearnDetailObj = value;
    },
    SET_CLASS_DATE_RANGE(state, value) {
      state.classDateRange = value;
    },
    SET_CLASS_KNOW_RANGE(state, value) {
      state.knowLedgeRange = value;
    },
    SET_KNOWLEDGE_PARAMS(state, value) {
      state.knowLedgeParams = value;
    },
    SET_CLASS_COURSE_LIST(state, value) {
      state.classCourseList = value;
    },
  },
  actions: {},
  getters,
});
